import { createCachedSelector, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { IStream } from '@cbridge-packages/stream';
import { selectedStreamIdSelector } from '../../../_selectors/selectedStreamId.selector';

export const streamPropsSelector = createCachedSelector(
  [
    selectedStreamIdSelector,
    prop<{ streamId: IStream['streamId'] }>().streamId(),
  ],
  (selectedStream, streamId) => {
    return {
      isSelected: selectedStream === streamId,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ streamId: IStream['streamId'] }>().streamId(),
});
